var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNubePequeaIzquierdaAzulBirdybacker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 207,
    viewBox: "0 0 321 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-128 206.96L224.18 205.85C246.85 206.25 265.44 187.99 265.44 165.32C265.44 142.93 247.29 124.78 224.9 124.78H112.03C93.61 124.78 78.68 109.85 78.68 91.43C78.68 73.01 93.61 58.08 112.03 58.08H291.33C307.37 58.08 320.37 45.08 320.37 29.04C320.37 13 307.37 0 291.33 0H-128V206.97V206.96Z",
    fill: "#B5EAD7",
    fillOpacity: 0.31
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNubePequeaIzquierdaAzulBirdybacker);
export default __webpack_public_path__ + "static/media/nube-pequeña-izquierda-azul-birdybacker.5263d887519d69d16ff7f32966f62a6c.svg";
export { ForwardRef as ReactComponent };